import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatTab, MatTabGroup, MatTabLabel} from "@angular/material/tabs";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-day-detail',
    templateUrl: './element.component.html',
    imports: [
        MatTabGroup,
        MatTab,
        TranslatePipe,
        MatTabLabel
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./element.component.scss']
})
export class ElementComponent implements OnInit {

    elementTabIndex = 0;

    elements: string [] = ["fire", "earth", "air", "water"]

    constructor(
        @Inject(MAT_DIALOG_DATA) public elementId: string
    ) {
    }

    ngOnInit(): void {
        this.initActiveTab();
    }

    private initActiveTab() {
        const tabIndex = this.elements.indexOf(this.elementId, 0)
        this.elementTabIndex = tabIndex
    }
}
